import { ShareClassEnum } from '../enums/share-class-enum';

const CLASS_LABEL = 'Class';

export function buildShareClassDescriptor(shareClass: ShareClassEnum) {
  return shareClass ? `${shareClass} ${CLASS_LABEL}` : '';
}
